import { Button, HTMLTable } from "@blueprintjs/core";
import { observer } from "mobx-react";
import * as React from "react";
import { ICalcVar } from "../../model";
require("../../assets/css/components/CalcVarGrid.css");

interface CalcVarFcpGridProps {
  varsFcp: ICalcVar[];
  onMoveUp: (_var: ICalcVar) => void;
  onMoveDown: (_var: ICalcVar) => void;
  onEdit: (_var: ICalcVar) => void;
  onDelete: (_var: ICalcVar) => void;
}

interface CalcVarFcpGridState {
}

const COLORS = [
  "#2965CC",
  "#29A634",
  "#D99E0B",
  "#D13913",
  "#8F398F",
  "#00B3A4",
  "#DB2C6F",
  "#9BBF30",
  "#96622D",
  "#7157D9",
];

@observer
export class CalcVarFcpGrid
  extends React.Component<CalcVarFcpGridProps, CalcVarFcpGridState>
{
  render() {
    let vars = this.props.varsFcp?.map(_var => {
      let colorIdx = _var.order - 1;
      if (colorIdx > COLORS.length - 1) {
        colorIdx = (_var.order - 1) % COLORS.length;
      }
      let color = COLORS[colorIdx];

      return (
        <tr key={_var.id}>
          <td style={{ width: 30 }}>{_var.order}</td>
          <td style={{ width: 150, color: color, fontWeight: "bold" }}>
            {_var.nome}
          </td>
          <td style={{ width: 300, fontSize: 11 }}>{_var.descricao}</td>
          <td className="calc-var-grid-expr">{_var.expr}</td>
          <td className="nz-table-actions">
            <Button
              small
              minimal
              icon="trash"
              onClick={(_: any) => this.props.onDelete(_var)}
            />
            <Button
              small
              minimal
              icon="arrow-up"
              onClick={(_: any) => this.props.onMoveUp(_var)}
            />
            <Button
              small
              minimal
              icon="arrow-down"
              onClick={(_: any) => this.props.onMoveDown(_var)}
            />
            <Button
              small
              minimal
              icon="edit"
              onClick={(_: any) => this.props.onEdit(_var)}
            />
          </td>
        </tr>
      );
    });

    return (
      <HTMLTable className="nz-table" style={{ width: "100%", marginBottom: "20px" }}>
        <tbody>
          {vars}
        </tbody>
      </HTMLTable>
    );
  }
}
